(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sb-info-tabs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sb-tabs')) {
    customElements.define(
      'sb-tabs',
      class extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
          this.tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => this.select(index));
            tab.addEventListener('keydown', (event) => {
              if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
              event.preventDefault();
              const step = event.key === 'ArrowRight' ? 1 : -1;
              const next = (index + step + this.tabs.length) % this.tabs.length;
              this.select(next);
              this.tabs[next].focus();
            });
          });
        }

        select(index) {
          this.tabs.forEach((tab, i) => {
            const active = i === index;
            tab.setAttribute('aria-selected', active ? 'true' : 'false');
            tab.tabIndex = active ? 0 : -1;
            const panel = document.getElementById(tab.getAttribute('aria-controls'));
            if (panel) panel.hidden = !active;
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
